import React, { FC, forwardRef } from 'react'
import { Form, Input, InputProps, Label, SemanticWIDTHS } from 'semantic-ui-react'

type Props = {
  ref?: any
  errorMessage?: any
  required?: boolean
  width?: SemanticWIDTHS
} & InputProps

const InputText: FC<Props> = forwardRef(({
  errorMessage, required, thelabel, width, ...props
}, ref) => {

  if (props.name == 'society' || props.name == 'lastName') {
    if (props?.errors?.lastName?.message && props.name == 'lastName') {
      //errorMessage = props.errors?.lastName?.message + ' ' + props.or + ' ' + props.errors?.society?.message
    }
    else{
      errorMessage = ''
    }
  }

  return (
    <Form.Field width={width} required={required} data-name={props.name} >
      <label>{thelabel}</label>
      <Input {...props} />
      {errorMessage &&
        <Label basic color="red" pointing>
          {errorMessage}
        </Label>
      }
    </Form.Field>
  )
})

export default InputText